import Checkpoints from './Checkpoints';
import Divider from './Divider';
import Document from './Document';
import Header from './Header';
import TextBlock from './Text';
import Textbox from './Textbox';
import TotalCosts from './TotalCosts';
import TripEvent from './TripEvent';
import { TPDFConfig, TPDFConfigType } from './types';

const defaultConfig: TPDFConfig = {
  header: {
    Component: Header,
  },
  text: {
    Component: TextBlock,
  },
  totalCosts: {
    Component: TotalCosts,
  },
  document: {
    Component: Document,
  },
  divider: {
    Component: Divider,
  },
  checkpoints: {
    Component: Checkpoints,
  },
  textbox: {
    Component: Textbox,
  },
  trip_event: {
    Component: TripEvent,
  },
};

export function getBlockConfig({ type }: { type: TPDFConfigType }) {
  if (!defaultConfig[type]) {
    return { Component: null };
  }

  return defaultConfig[type];
}
